import { FormControl, InputLabel, MenuItem, Select, type SelectProps } from '@mui/material'
import React, { useMemo } from 'react'

import {
	compareBillingLogEntriesForDisplay,
	formatBillingLogEntryOptionLabel,
	type BillingLogEntryResponse,
} from '../../types/Contracts/BillingLog'

type BillingLogSelectProps = {
	value: number | null
	onChange: (billingLogEntryId: number | null) => void
	logs: BillingLogEntryResponse[]
	loading?: boolean
	disabled?: boolean
	label?: string
	className?: string
	selectSx?: SelectProps['sx']
}

export function BillingLogSelect({
	value,
	onChange,
	logs,
	loading = false,
	disabled = false,
	label = 'Billing Entry',
	className,
	selectSx,
}: BillingLogSelectProps) {
	const labelId = React.useId()
	const options = useMemo(() => {
		const sorted = [...logs].sort(compareBillingLogEntriesForDisplay)
		if (value != null && !sorted.some((log) => log.id === value)) {
			return [
				{
					id: value,
					purchaseOrder: '',
					workOrder: '',
					contractAfe: null,
					costCode: null,
					line: null,
					projectId: 0,
				},
				...sorted,
			]
		}
		return sorted
	}, [logs, value])

	return (
		<FormControl className={className} size='small' fullWidth disabled={disabled || loading}>
			<InputLabel id={labelId}>{label}</InputLabel>
			<Select
				labelId={labelId}
				label={label}
				value={value != null ? String(value) : ''}
				onChange={(e) => {
					const next = e.target.value
					onChange(next === '' ? null : Number(next))
				}}
				sx={selectSx}
			>
				<MenuItem value=''>
					<em>—</em>
				</MenuItem>
				{options.map((log) => (
					<MenuItem key={log.id} value={String(log.id)}>
						{formatBillingLogEntryOptionLabel(log)}
					</MenuItem>
				))}
			</Select>
		</FormControl>
	)
}
